(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-corporate-pass"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-tt-pass-direct-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.tt_pass_btn__rh');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1
            })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-course-catelogue"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function isValidEmail(value) {
      return emailPattern.test(String(value || '').trim());
    }

    function triggerDownload(url) {
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '');
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    document.querySelectorAll('[data-tt-catalogue-download-form]').forEach(function (form) {
      var emailInput = form.querySelector('[data-tt-catalogue-email]');
      var submitBtn = form.querySelector('[data-tt-catalogue-submit]');
      var statusEl = form.querySelector('[data-tt-catalogue-status]');
      var downloadUrl = form.getAttribute('data-download-url');

      if (!emailInput || !submitBtn) return;

      function updateButtonState() {
        var valid = isValidEmail(emailInput.value);
        var hasFile = Boolean(downloadUrl);
        submitBtn.disabled = !valid || !hasFile;
      }

      function showStatus(message, isError) {
        if (!statusEl) return;
        statusEl.textContent = message;
        statusEl.hidden = false;
        statusEl.style.color = isError ? '#fca5a5' : '#86efac';
      }

      emailInput.addEventListener('input', updateButtonState);
      emailInput.addEventListener('change', updateButtonState);
      updateButtonState();

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = emailInput.value.trim();
        if (!isValidEmail(email) || !downloadUrl) return;

        submitBtn.disabled = true;

        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', '\u2713');
        body.append('contact[email]', email);
        body.append('contact[tags]', form.getAttribute('data-subscription-tag') || 'newsletter');

        fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'text/html'
          },
          credentials: 'same-origin',
          body: body.toString()
        })
          .then(function (response) {
            if (!response.ok) throw new Error('subscribe');
            triggerDownload(downloadUrl);
            showStatus(form.getAttribute('data-success-message') || 'Download started.', false);
          })
          .catch(function () {
            showStatus(form.getAttribute('data-error-message') || 'Something went wrong. Please try again.', true);
          })
          .finally(function () {
            updateButtonState();
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-customized-plan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tt-custom-plan-message]').forEach(function (textarea) {
      var sectionRoot = textarea.closest('.tt_custom_plan_section__rh');
      if (!sectionRoot) return;

      var counter = sectionRoot.querySelector('[data-tt-custom-plan-counter]');
      if (!counter) return;

      var maxLength = Number(textarea.getAttribute('data-max-length')) || 500;

      function updateCounter() {
        counter.textContent = '(' + textarea.value.length + '/' + maxLength + ')';
      }

      textarea.addEventListener('input', updateCounter);
      updateCounter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    function isMobile() {
      return mobileQuery.matches;
    }

    function setAnswerHeight(item, open) {
      var answer = item.querySelector('[data-tt-faq-answer]');
      if (!answer || !isMobile()) return;

      if (open) {
        answer.style.setProperty('--tt-faq-answer-height', answer.scrollHeight + 'px');
        item.classList.add('tt_faq_item--open__rh');
      } else {
        answer.style.setProperty('--tt-faq-answer-height', '0px');
        item.classList.remove('tt_faq_item--open__rh');
      }
    }

    function refreshOpenHeights(list) {
      if (!isMobile()) return;
      list.querySelectorAll('.tt_faq_item--open__rh').forEach(function (item) {
        setAnswerHeight(item, true);
      });
    }

    function closeAllExcept(list, activeItem) {
      list.querySelectorAll('[data-tt-faq-item]').forEach(function (item) {
        if (item === activeItem) return;
        var trigger = item.querySelector('[data-tt-faq-toggle]');
        setAnswerHeight(item, false);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleItem(list, item, trigger) {
      if (!isMobile()) return;

      var willOpen = !item.classList.contains('tt_faq_item--open__rh');
      if (willOpen) closeAllExcept(list, item);
      setAnswerHeight(item, willOpen);
      if (trigger) trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    document.querySelectorAll('[data-tt-faq-list]').forEach(function (list) {
      list.querySelectorAll('[data-tt-faq-item]').forEach(function (item) {
        var trigger = item.querySelector('[data-tt-faq-toggle]');
        if (!trigger) return;

        if (item.classList.contains('tt_faq_item--open__rh')) {
          setAnswerHeight(item, true);
        } else if (isMobile()) {
          setAnswerHeight(item, false);
        }

        if (!isMobile()) {
          trigger.setAttribute('tabindex', '-1');
        }

        trigger.addEventListener('click', function () {
          toggleItem(list, item, trigger);
        });

        trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggleItem(list, item, trigger);
        });
      });

      mobileQuery.addEventListener('change', function () {
        list.querySelectorAll('[data-tt-faq-item]').forEach(function (item) {
          var answer = item.querySelector('[data-tt-faq-answer]');
          var trigger = item.querySelector('[data-tt-faq-toggle]');
          if (!isMobile()) {
            item.classList.remove('tt_faq_item--open__rh');
            if (answer) answer.style.removeProperty('--tt-faq-answer-height');
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'false');
              trigger.setAttribute('tabindex', '-1');
            }
          } else if (item.classList.contains('tt_faq_item--open__rh')) {
            setAnswerHeight(item, true);
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'true');
              trigger.setAttribute('tabindex', '0');
            }
          } else {
            setAnswerHeight(item, false);
            if (trigger) trigger.setAttribute('tabindex', '0');
          }
        });
      });

      window.addEventListener('resize', function () {
        refreshOpenHeights(list);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-floating-bar-bottom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-rh-floating-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.tt_float_bar_btn__rh');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1,
            }),
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  (function () {
    var bars = document.querySelectorAll('[data-rh-floating-bar-root]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var triggerId = (bar.getAttribute('data-trigger-id') || '').trim();

      if (!triggerId) {
        bar.classList.add('is-visible');
        return;
      }

      var triggerElement = document.getElementById(triggerId);
      if (!triggerElement) {
        bar.classList.add('is-visible');
        return;
      }

      var updateVisibility = function () {
        var rect = triggerElement.getBoundingClientRect();
        var hasPassedTrigger = rect.bottom <= 0;
        bar.classList.toggle('is-visible', hasPassedTrigger);
      };

      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-pricing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-tt-pricing-direct-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.tt_pricing_btn__rh');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1
            })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
